var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_modal" }, [
    _c("div", { staticClass: "setting_customize" }, [
      _c("div", { staticClass: "setting_customize_header" }, [
        _c("p", { staticClass: "setting_customize_header_title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.labelProperties.PREVIEW_TITLE) +
              "\n      "
          )
        ]),
        _c(
          "div",
          {
            staticClass: "setting_customize_header_close",
            on: { click: _vm.closeModal }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "12",
                  height: "12",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("g", { attrs: { fill: "#AAA", "fill-rule": "evenodd" } }, [
                  _c("path", {
                    attrs: { d: "M.255 1.545l.99-.99 9.9 9.9-.99.99z" }
                  }),
                  _c("path", {
                    attrs: { d: "M10.155.555l.99.99-9.9 9.9-.99-.99z" }
                  })
                ])
              ]
            )
          ]
        )
      ]),
      _c("div", { staticClass: "setting_customize_body" }, [
        _c(
          "div",
          {
            staticClass: "setting_customize_preview",
            style: { backgroundColor: _vm.colors.pageBackground }
          },
          [
            _c("div", { staticClass: "jobs_wrapper" }, [
              _vm.entryPageName
                ? _c(
                    "h1",
                    {
                      staticClass: "jobs_page_title_preview setting_word_break",
                      style: { color: _vm.colors.pageText }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.entryPageName) +
                          "\n          "
                      )
                    ]
                  )
                : _c(
                    "h1",
                    {
                      staticClass: "jobs_page_title",
                      style: { color: _vm.colors.pageText }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.labelProperties.ENTRY_PAGE_TITLE) +
                          "\n          "
                      )
                    ]
                  ),
              _vm.entryOverview
                ? _c(
                    "p",
                    {
                      staticClass:
                        "jobs_table_annotation_preview setting_word_break"
                    },
                    [_vm._v(_vm._s(_vm.entryOverview))]
                  )
                : _vm._e(),
              _c("div", { staticClass: "entry_stepbar" }, [
                _c(
                  "ul",
                  {
                    staticClass: "entry_stepbar_list",
                    style: { border: "1px solid" + _vm.colors.borderColor }
                  },
                  [
                    _c(
                      "li",
                      {
                        staticClass: "entry_stepbar_item",
                        style: [
                          _vm.step >= 1
                            ? {
                                backgroundColor: _vm.colors.keyColor,
                                "--keyColor": _vm.colors.keyColor
                              }
                            : {}
                        ]
                      },
                      [
                        _vm.message &&
                        _vm.message.titleEntry &&
                        _vm.message.titleEntry.length <=
                          _vm.messageSettingsProperties.TITLE
                            .ENTRY_TITLE_MAX_LENGTH
                          ? _c(
                              "span",
                              {
                                staticClass: "entry_stepbar_label",
                                style: [
                                  _vm.step >= 1
                                    ? { color: _vm.colors.highlightText }
                                    : {}
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.message.titleEntry) +
                                    "\n                "
                                )
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass: "entry_stepbar_label",
                                style: [
                                  _vm.step >= 1
                                    ? { color: _vm.colors.highlightText }
                                    : {}
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.labelProperties.ENTRY_STEP_TITLE
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                      ]
                    ),
                    _c(
                      "li",
                      {
                        staticClass: "entry_stepbar_item",
                        style: [
                          _vm.step >= 2
                            ? {
                                backgroundColor: _vm.colors.keyColor,
                                "--keyColor": _vm.colors.keyColor
                              }
                            : {
                                backgroundColor: _vm.colors.subColor,
                                "--keyColor": _vm.colors.subColor
                              }
                        ]
                      },
                      [
                        _vm.message &&
                        _vm.message.titleConfirm &&
                        _vm.message.titleConfirm.length <=
                          _vm.messageSettingsProperties.TITLE
                            .CONFIRM_TITLE_MAX_LENGTH
                          ? _c(
                              "span",
                              {
                                staticClass: "entry_stepbar_label",
                                style: [
                                  _vm.step >= 2
                                    ? { color: _vm.colors.highlightText }
                                    : { color: _vm.colors.pageText }
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.message.titleConfirm) +
                                    "\n                "
                                )
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass: "entry_stepbar_label",
                                style: [
                                  _vm.step >= 2
                                    ? { color: _vm.colors.highlightText }
                                    : { color: _vm.colors.pageText }
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.labelProperties.CONFIRM_STEP_TITLE
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                      ]
                    ),
                    _c(
                      "li",
                      {
                        staticClass: "entry_stepbar_item",
                        style: [
                          _vm.step >= 3
                            ? {
                                backgroundColor: _vm.colors.keyColor,
                                "--keyColor": _vm.colors.keyColor
                              }
                            : { backgroundColor: _vm.colors.subColor }
                        ]
                      },
                      [
                        _vm.message &&
                        _vm.message.titleCompletion &&
                        _vm.message.titleCompletion.length <=
                          _vm.messageSettingsProperties.TITLE
                            .COMPLETE_TITLE_MAX_LENGTH
                          ? _c(
                              "span",
                              {
                                staticClass: "entry_stepbar_label",
                                style: [
                                  _vm.step >= 3
                                    ? { color: _vm.colors.highlightText }
                                    : { color: _vm.colors.pageText }
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.message.titleCompletion) +
                                    "\n                "
                                )
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass: "entry_stepbar_label",
                                style: [
                                  _vm.step >= 3
                                    ? { color: _vm.colors.highlightText }
                                    : { color: _vm.colors.pageText }
                                ]
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.labelProperties.COMPLETE_STEP_TITLE
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                      ]
                    )
                  ]
                )
              ]),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === 1,
                      expression: "step === 1"
                    }
                  ],
                  style: { backgroundColor: _vm.colors.pageBackground }
                },
                [
                  _vm.draftCategories.length > 0
                    ? _c(
                        "div",
                        _vm._l(_vm.draftCategories, function(category, index) {
                          return _c("div", { key: index }, [
                            category &&
                            !category.categoryDeleted &&
                            !_vm.isEmptyCategory(index)
                              ? _c("div", { staticClass: "mt-2" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass: "jobs_category_title",
                                      style: {
                                        color: _vm.colors.pageText,
                                        borderLeftColor: _vm.colors.keyColor
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(category.categoryName) +
                                          "\n                    "
                                      ),
                                      category.countCate
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(category.countCate) +
                                                "\n                    "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "jobs_table_wrapper" },
                                    _vm._l(category.item, function(
                                      item,
                                      indexItem
                                    ) {
                                      return _c(
                                        "table",
                                        {
                                          key: indexItem,
                                          staticClass: "jobs_table"
                                        },
                                        [
                                          !_vm.isEmptyItem(item)
                                            ? [
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "jobs_table_body"
                                                  },
                                                  [
                                                    _c(
                                                      "tr",
                                                      {
                                                        staticClass:
                                                          "jobs_table_rows"
                                                      },
                                                      [
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "jobs_table_head",
                                                            style: [
                                                              {
                                                                backgroundColor:
                                                                  _vm.colors
                                                                    .subColor
                                                              },
                                                              indexItem === 0
                                                                ? {
                                                                    border:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                                : {
                                                                    borderLeft:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderRight:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderBottom:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                            ]
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "jobs_table_head_holder"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "jobs_table_label",
                                                                    style: {
                                                                      color:
                                                                        _vm
                                                                          .colors
                                                                          .pageText
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.itemName
                                                                        ) +
                                                                        "\n                              "
                                                                    )
                                                                  ]
                                                                ),
                                                                item.itemRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "entry_required_label",
                                                                        style: {
                                                                          backgroundColor:
                                                                            _vm
                                                                              .colors
                                                                              .requiredLabel,
                                                                          color:
                                                                            _vm
                                                                              .colors
                                                                              .requiredLabelText
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .labelProperties
                                                                                .LABEL_REQUIRE
                                                                            ) +
                                                                            "\n                              "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            item.resourceField
                                                              .length === 1 &&
                                                            (item
                                                              .resourceField[0]
                                                              .min_length ||
                                                              item
                                                                .resourceField[0]
                                                                .max_length)
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "setting_range_allow_input"
                                                                  },
                                                                  [
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "textarea" ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "text" ||
                                                                    item.resourceField[0].type.includes(
                                                                      "email"
                                                                    ) ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "tel" ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "url"
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .labelProperties
                                                                                  .WORD_COUNT
                                                                              ) +
                                                                                " " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .min_length
                                                                                ) +
                                                                                " ~ " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .max_length
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "integer" ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "calc" ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "number"
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .labelProperties
                                                                                  .RANGE
                                                                              ) +
                                                                                " " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .min_length
                                                                                ) +
                                                                                " ~ " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .max_length
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "jobs_table_cell",
                                                            style: [
                                                              indexItem === 0
                                                                ? {
                                                                    border:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                                : {
                                                                    borderLeft:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderRight:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderBottom:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                            ]
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "jobs_table_form_rows"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "jobs_table_form_item"
                                                                  },
                                                                  [
                                                                    _vm._l(
                                                                      _vm.buildListItem(
                                                                        item.resourceField
                                                                      ),
                                                                      function(
                                                                        resourceField,
                                                                        indexResourceField
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: indexResourceField,
                                                                            staticClass:
                                                                              "row"
                                                                          },
                                                                          _vm._l(
                                                                            resourceField.filter(
                                                                              function(
                                                                                resourceSetting
                                                                              ) {
                                                                                return (
                                                                                  resourceSetting &&
                                                                                  !resourceSetting.isDeletedByMainSystem
                                                                                )
                                                                              }
                                                                            ),
                                                                            function(
                                                                              resource,
                                                                              indexResource
                                                                            ) {
                                                                              return _c(
                                                                                "div",
                                                                                {
                                                                                  key: indexResource,
                                                                                  staticClass:
                                                                                    "col"
                                                                                },
                                                                                [
                                                                                  resource.type !==
                                                                                  "blank"
                                                                                    ? _c(
                                                                                        "div",
                                                                                        [
                                                                                          _c(
                                                                                            "InputComponent",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mt-2",
                                                                                              attrs: {
                                                                                                resource: resource,
                                                                                                indexResource: indexResourceField,
                                                                                                master: _vm.getMasterData(
                                                                                                  resource.master_name
                                                                                                ),
                                                                                                year:
                                                                                                  _vm.year,
                                                                                                month:
                                                                                                  _vm.month,
                                                                                                day:
                                                                                                  _vm.day,
                                                                                                draftColors:
                                                                                                  _vm.colors,
                                                                                                isDisableEditing:
                                                                                                  _vm.isDisableEditing,
                                                                                                numberOfItem:
                                                                                                  item
                                                                                                    .resourceField
                                                                                                    .length,
                                                                                                itemName:
                                                                                                  item.itemName
                                                                                              }
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _vm._e()
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          0
                                                                        )
                                                                      }
                                                                    ),
                                                                    item.viewAnnotation
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "jobs_table_annotation setting_word_break",
                                                                            style: {
                                                                              color:
                                                                                _vm
                                                                                  .colors
                                                                                  .pageText
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                  ※" +
                                                                                _vm._s(
                                                                                  item.annotationText
                                                                                ) +
                                                                                "\n                                "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  2
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  ),
                                  index === _vm.findLastCategoryIndex("careers")
                                    ? _c(
                                        "div",
                                        { staticClass: "setting_unit_add" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "setting_unit_add_btn",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.duplicateCategory(
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.labelProperties
                                                      .DUPLICATE_CARRIER
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  index ===
                                  _vm.findLastCategoryIndex("educations")
                                    ? _c(
                                        "div",
                                        { staticClass: "setting_unit_add" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "setting_unit_add_btn",
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.duplicateCategory(
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.labelProperties
                                                      .DUPLICATE_EDUCATION
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.privacy.isEnabledPolicy && _vm.privacy.content !== ""
                    ? _c("div", { staticClass: "mt-2" }, [
                        _c(
                          "h2",
                          {
                            staticClass: "jobs_category_title",
                            style: {
                              color: _vm.colors.pageText,
                              borderLeftColor: _vm.colors.keyColor
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.labelProperties.PRIVACY_POLICY_CATEGORY
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.privacy.content,
                              expression: "privacy.content"
                            }
                          ],
                          staticClass: "jobs_form_textarea",
                          attrs: { readonly: "" },
                          domProps: { value: _vm.privacy.content },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.privacy,
                                "content",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("div", { staticClass: "entry_policy_checkbox" }, [
                          _c("label", { staticClass: "jobs_form_label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.agreePrivacyPolicy,
                                  expression: "agreePrivacyPolicy"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.agreePrivacyPolicy)
                                  ? _vm._i(_vm.agreePrivacyPolicy, null) > -1
                                  : _vm.agreePrivacyPolicy
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.agreePrivacyPolicy,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.agreePrivacyPolicy = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.agreePrivacyPolicy = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.agreePrivacyPolicy = $$c
                                  }
                                }
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "entry_policy_checkbox_text",
                                style: { color: _vm.colors.pageText }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.labelProperties.PRIVACY_POLICY_DEFAULT
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.privacy.isEnabledUrl && _vm.privacy.textLink !== ""
                    ? _c("div", { staticClass: "entry_policy_checkbox" }, [
                        _c("label", { staticClass: "jobs_form_label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.agreePrivacyPolicyLink,
                                expression: "agreePrivacyPolicyLink"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.agreePrivacyPolicyLink)
                                ? _vm._i(_vm.agreePrivacyPolicyLink, null) > -1
                                : _vm.agreePrivacyPolicyLink
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.agreePrivacyPolicyLink,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.agreePrivacyPolicyLink = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.agreePrivacyPolicyLink = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.agreePrivacyPolicyLink = $$c
                                }
                              }
                            }
                          }),
                          _c(
                            "a",
                            {
                              staticClass: "ml-1 mr-3",
                              style: { color: _vm.colors.linkText },
                              attrs: { href: _vm.privacy.url, target: "_blank" }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.privacy.textLink) +
                                  "\n                "
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "jobs_btn_box" }, [
                    _c(
                      "button",
                      {
                        staticClass: "jobs_btn_primary",
                        style: {
                          color: _vm.colors.mainButtonText,
                          backgroundColor: _vm.colors.mainButton,
                          border: "1px solid" + _vm.colors.borderColor
                        },
                        on: {
                          click: function($event) {
                            return _vm.nextStep(2)
                          }
                        }
                      },
                      [
                        !_vm.button.confirmButton ||
                        _vm.button.confirmButton.length >
                          _vm.buttonSettingsProperties.CONFIRM_BUTTON_MAX_LENGTH
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.labelProperties.CONFIRM_BUTTON) +
                                  "\n                "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.button.confirmButton) +
                                  "\n                "
                              )
                            ])
                      ]
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === 2,
                      expression: "step === 2"
                    }
                  ],
                  style: { backgroundColor: _vm.colors.pageBackground }
                },
                [
                  _c("div", { staticClass: "entry_confirm" }, [
                    _vm.message &&
                    _vm.message.messageConfirm &&
                    _vm.message.messageConfirm.length <=
                      _vm.messageSettingsProperties.MESSAGE
                        .CONFIRM_BODY_MAX_LENGTH
                      ? _c(
                          "pre",
                          {
                            staticClass:
                              "entry_confirm_text customize_setting_entry_confirm"
                          },
                          [_vm._v(_vm._s(_vm.message.messageConfirm))]
                        )
                      : _vm._e()
                  ]),
                  _vm.draftCategories.length > 0
                    ? _c(
                        "div",
                        _vm._l(_vm.draftCategories, function(category, index) {
                          return _c("div", { key: index }, [
                            category &&
                            !category.categoryDeleted &&
                            !_vm.isEmptyCategory(index)
                              ? _c("div", { staticClass: "mt-2" }, [
                                  _c(
                                    "h2",
                                    {
                                      staticClass: "jobs_category_title",
                                      style: {
                                        color: _vm.colors.pageText,
                                        borderLeftColor: _vm.colors.keyColor
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(category.categoryName) +
                                          "\n                    "
                                      ),
                                      category.countCate
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(category.countCate) +
                                                "\n                    "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "jobs_table_wrapper" },
                                    _vm._l(category.item, function(
                                      item,
                                      indexItem
                                    ) {
                                      return _c(
                                        "table",
                                        {
                                          key: indexItem,
                                          staticClass: "jobs_table"
                                        },
                                        [
                                          !_vm.isEmptyItem(item)
                                            ? [
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "jobs_table_body"
                                                  },
                                                  [
                                                    _c(
                                                      "tr",
                                                      {
                                                        staticClass:
                                                          "jobs_table_rows"
                                                      },
                                                      [
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "jobs_table_head",
                                                            style: [
                                                              {
                                                                backgroundColor:
                                                                  _vm.colors
                                                                    .subColor
                                                              },
                                                              indexItem === 0
                                                                ? {
                                                                    border:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                                : {
                                                                    borderLeft:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderRight:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderBottom:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                            ]
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "jobs_table_head_holder"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "jobs_table_label",
                                                                    style: {
                                                                      color:
                                                                        _vm
                                                                          .colors
                                                                          .pageText
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          item.itemName
                                                                        ) +
                                                                        "\n                              "
                                                                    )
                                                                  ]
                                                                ),
                                                                item.itemRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "entry_required_label",
                                                                        style: {
                                                                          backgroundColor:
                                                                            _vm
                                                                              .colors
                                                                              .requiredLabel,
                                                                          color:
                                                                            _vm
                                                                              .colors
                                                                              .requiredLabelText
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .labelProperties
                                                                                .LABEL_REQUIRE
                                                                            ) +
                                                                            "\n                              "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            ),
                                                            item.resourceField
                                                              .length === 1 &&
                                                            (item
                                                              .resourceField[0]
                                                              .min_length ||
                                                              item
                                                                .resourceField[0]
                                                                .max_length)
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "setting_range_allow_input"
                                                                  },
                                                                  [
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "textarea" ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "text" ||
                                                                    item.resourceField[0].type.includes(
                                                                      "email"
                                                                    ) ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "tel" ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "url"
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .labelProperties
                                                                                  .WORD_COUNT
                                                                              ) +
                                                                                " " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .min_length
                                                                                ) +
                                                                                " ~ " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .max_length
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "integer" ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "calc" ||
                                                                    item
                                                                      .resourceField[0]
                                                                      .type ===
                                                                      "number"
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .labelProperties
                                                                                  .RANGE
                                                                              ) +
                                                                                " " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .min_length
                                                                                ) +
                                                                                " ~ " +
                                                                                _vm._s(
                                                                                  item
                                                                                    .resourceField[0]
                                                                                    .max_length
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "jobs_table_cell",
                                                            style: [
                                                              indexItem === 0
                                                                ? {
                                                                    border:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                                : {
                                                                    borderLeft:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderRight:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor,
                                                                    borderBottom:
                                                                      "1px solid" +
                                                                      _vm.colors
                                                                        .borderColor
                                                                  }
                                                            ]
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "jobs_table_form_rows"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "jobs_table_form_item"
                                                                  },
                                                                  [
                                                                    _vm._l(
                                                                      _vm.buildListItem(
                                                                        item.resourceField
                                                                      ),
                                                                      function(
                                                                        resourceField,
                                                                        indexResourceField
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: indexResourceField,
                                                                            staticClass:
                                                                              "row"
                                                                          },
                                                                          _vm._l(
                                                                            resourceField.filter(
                                                                              function(
                                                                                resourceSetting
                                                                              ) {
                                                                                return (
                                                                                  resourceSetting &&
                                                                                  !resourceSetting.isDeletedByMainSystem
                                                                                )
                                                                              }
                                                                            ),
                                                                            function(
                                                                              resource,
                                                                              indexResource
                                                                            ) {
                                                                              return _c(
                                                                                "div",
                                                                                {
                                                                                  key: indexResource,
                                                                                  staticClass:
                                                                                    "col"
                                                                                },
                                                                                [
                                                                                  resource.type !==
                                                                                  "blank"
                                                                                    ? _c(
                                                                                        "div",
                                                                                        [
                                                                                          _c(
                                                                                            "InputComponent",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mt-2",
                                                                                              attrs: {
                                                                                                resource: resource,
                                                                                                indexResource: indexResourceField,
                                                                                                master: _vm.getMasterData(
                                                                                                  resource.master_name
                                                                                                ),
                                                                                                year:
                                                                                                  _vm.year,
                                                                                                month:
                                                                                                  _vm.month,
                                                                                                day:
                                                                                                  _vm.day,
                                                                                                draftColors:
                                                                                                  _vm.colors,
                                                                                                isDisableEditing:
                                                                                                  _vm.isDisableEditing,
                                                                                                numberOfItem:
                                                                                                  item
                                                                                                    .resourceField
                                                                                                    .length,
                                                                                                itemName:
                                                                                                  item.itemName
                                                                                              }
                                                                                            }
                                                                                          )
                                                                                        ],
                                                                                        1
                                                                                      )
                                                                                    : _vm._e()
                                                                                ]
                                                                              )
                                                                            }
                                                                          ),
                                                                          0
                                                                        )
                                                                      }
                                                                    ),
                                                                    item.viewAnnotation
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "jobs_table_annotation setting_word_break",
                                                                            style: {
                                                                              color:
                                                                                _vm
                                                                                  .colors
                                                                                  .pageText
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                  ※" +
                                                                                _vm._s(
                                                                                  item.annotationText
                                                                                ) +
                                                                                "\n                                "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  2
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    }),
                                    0
                                  )
                                ])
                              : _vm._e()
                          ])
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm.privacy.isEnabledPolicy && _vm.privacy.content !== ""
                    ? _c("div", { staticClass: "mt-2" }, [
                        _c(
                          "h2",
                          {
                            staticClass: "jobs_category_title",
                            style: {
                              color: _vm.colors.pageText,
                              borderLeftColor: _vm.colors.keyColor
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.labelProperties.PRIVACY_POLICY_CATEGORY
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.privacy.content,
                              expression: "privacy.content"
                            }
                          ],
                          staticClass: "jobs_form_textarea",
                          attrs: { readonly: "" },
                          domProps: { value: _vm.privacy.content },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.privacy,
                                "content",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("div", { staticClass: "entry_policy_checkbox" }, [
                          _c("label", { staticClass: "jobs_form_label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.agreePrivacyPolicy,
                                  expression: "agreePrivacyPolicy"
                                }
                              ],
                              attrs: { type: "checkbox", disabled: "" },
                              domProps: {
                                checked: Array.isArray(_vm.agreePrivacyPolicy)
                                  ? _vm._i(_vm.agreePrivacyPolicy, null) > -1
                                  : _vm.agreePrivacyPolicy
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.agreePrivacyPolicy,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.agreePrivacyPolicy = $$a.concat([
                                          $$v
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.agreePrivacyPolicy = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.agreePrivacyPolicy = $$c
                                  }
                                }
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "entry_policy_checkbox_text",
                                style: { color: _vm.colors.pageText }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.labelProperties.PRIVACY_POLICY_DEFAULT
                                    ) +
                                    "\n                  "
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.privacy.isEnabledUrl && _vm.privacy.textLink !== ""
                    ? _c("div", { staticClass: "entry_policy_checkbox" }, [
                        _c("label", { staticClass: "jobs_form_label" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.agreePrivacyPolicyLink,
                                expression: "agreePrivacyPolicyLink"
                              }
                            ],
                            attrs: { type: "checkbox", disabled: "" },
                            domProps: {
                              checked: Array.isArray(_vm.agreePrivacyPolicyLink)
                                ? _vm._i(_vm.agreePrivacyPolicyLink, null) > -1
                                : _vm.agreePrivacyPolicyLink
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.agreePrivacyPolicyLink,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.agreePrivacyPolicyLink = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.agreePrivacyPolicyLink = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.agreePrivacyPolicyLink = $$c
                                }
                              }
                            }
                          }),
                          _c(
                            "a",
                            {
                              staticClass: "ml-1 mr-3",
                              style: { color: _vm.colors.linkText },
                              attrs: { href: _vm.privacy.url, target: "_blank" }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.privacy.textLink) +
                                  "\n                "
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "jobs_btn_box" }, [
                    _c(
                      "button",
                      {
                        staticClass: "jobs_btn_secondary",
                        style: {
                          color: _vm.colors.subButtonText,
                          backgroundColor: _vm.colors.subButton,
                          border: "1px solid" + _vm.colors.borderColor
                        },
                        on: {
                          click: function($event) {
                            return _vm.backStep(1)
                          }
                        }
                      },
                      [
                        !_vm.button.returnButton ||
                        _vm.button.returnButton.length >
                          _vm.buttonSettingsProperties.RETURN_BUTTON_MAX_LENGTH
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.labelProperties.BACK_BUTTON) +
                                  "\n                "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.button.returnButton) +
                                  "\n                "
                              )
                            ])
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "jobs_btn_primary",
                        style: {
                          color: _vm.colors.mainButtonText,
                          backgroundColor: _vm.colors.mainButton,
                          border: "1px solid" + _vm.colors.borderColor
                        },
                        on: {
                          click: function($event) {
                            _vm.step = 3
                          }
                        }
                      },
                      [
                        !_vm.button.entryButton ||
                        _vm.button.entryButton.length >
                          _vm.buttonSettingsProperties.ENTRY_BUTTON_MAX_LENGTH
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.labelProperties.ENTRY_BUTTON) +
                                  "\n                "
                              )
                            ])
                          : _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.button.entryButton) +
                                  "\n                "
                              )
                            ])
                      ]
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step === 3,
                      expression: "step === 3"
                    }
                  ],
                  style: { backgroundColor: _vm.colors.pageBackground }
                },
                [
                  _c("div", { staticClass: "entry_complete" }, [
                    _c("p", { staticClass: "entry_complete_title" }, [
                      _vm.message &&
                      _vm.message.messageTitleCompletion &&
                      _vm.message.messageTitleCompletion.length <=
                        _vm.messageSettingsProperties.MESSAGE
                          .COMPLETE_TITLE_MAX_LENGTH
                        ? _c("span", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.message.messageTitleCompletion) +
                                "\n                "
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  _vm.labelProperties
                                    .MESSAGE_TITLE_COMPLETION_DEFAULT
                                ) +
                                "\n                "
                            )
                          ])
                    ]),
                    _vm.message &&
                    _vm.message.messageBodyCompletion &&
                    _vm.message.messageBodyCompletion.length <=
                      _vm.messageSettingsProperties.MESSAGE
                        .COMPLETE_BODY_MAX_LENGTH
                      ? _c(
                          "pre",
                          {
                            staticClass:
                              "entry_complete_text customize_setting_entry_confirm mt-3"
                          },
                          [_vm._v(_vm._s(_vm.message.messageBodyCompletion))]
                        )
                      : _c("p", { staticClass: "entry_complete_text mt-5" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.labelProperties.MESSAGE_CONTENT_1) +
                              "\n                "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.labelProperties.MESSAGE_CONTENT_2) +
                              "\n              "
                          )
                        ])
                  ])
                ]
              )
            ])
          ]
        )
      ]),
      _c("div", { staticClass: "setting_customize_footer" }, [
        _c("div", { staticClass: "setting_customize_footer_button" }, [
          _c(
            "button",
            {
              staticClass: "setting_btn_outline setting_btn_small",
              on: { click: _vm.closeModal }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.labelProperties.BUTTON_CLOSE_MODAL) +
                  "\n        "
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }